module.exports = __webpack_public_path__ + "static/WB2-05f2e8d6e8a7c1356d97569395c2204f.jpg";